// extracted by mini-css-extract-plugin
export default {"sectionBlue":"sectionBlue_sectionBlue__ZJ8N6","title":"sectionBlue_title__8Wp+6","button":"sectionBlue_button__eBitS"};